import React, { Component } from 'react';
import { Translation } from 'react-i18next';

import PlannerResourceForm from '../containers/PlannerResourceFormContainer';
import DocumentHead from '../../../elements/components/DocumentHead';
import Logger from '../../../../../lib/Logger';

class PlannerResourceEditScreen extends Component {
  scrollToTop = () => {
    Logger.log('debug', `PlannerResourceEditScreen.scrollToTop()`);
    if (typeof window !== 'undefined') {
      setTimeout(() => window.scrollTo(0, 0), 100);
    }
  };

  render() {
    return (
      <Translation>
        {(t) => (
          <div>
            <DocumentHead title={t('planner_resources_route_edit')} />
            <PlannerResourceForm id={this.props.match.params.id} />
          </div>
        )}
      </Translation>
    );
  }

  /* LIFECYCLE EVENTS */

  componentDidMount() {
    this.scrollToTop();
  }
}

export default PlannerResourceEditScreen;

Logger.log('silly', `PlannerResourceEditScreen loaded.`);
